import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { DateTimeService } from '@shared/services/DateTimeService';
import media from '../../../utils/mediaQueries';
import Btn from '../../buttons/Btn';
import { LicenseTypes } from '../../../constants/LicenseTypes';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  ${media.mobile`
    flex-direction: column;
    align-items: flex-start;
  `}
`;

const Info = styled.div`
  font-size: 18px;
  line-height: 1.44;
  letter-spacing: 0.2px;
  margin-right: 16px;

  ${media.mobile`
    margin-right: 0;
    margin-bottom: 8px;
  `}
`;

const Strong = styled.span`
  font-weight: bold;
`;

const Static = ({
  location, license, date, onModifyClick, isRecoveryPoints,
}) => {
  const handleModifyClick = useCallback(() => onModifyClick(true), []);

  return (
    <Container>
      <Info>
        {isRecoveryPoints ? 'Vous souhaitez effectuer un ' : 'Vous souhaitez passer '}
        {isRecoveryPoints ? (
          <Strong>Stage de récupération de points</Strong>
        ) : (
          <Strong>
            le code
            {license === LicenseTypes.ETM ? ' moto' : ' voiture'}
            {` (${license})`}
          </Strong>
        )}

        {' le '}
        <Strong>{DateTimeService.setDateLocale(new Date(date), 'd MMM yyyy')}</Strong>
        {' à '}
        <Strong>{location}</Strong>
      </Info>
      <Btn outlined small text="Modifier" onClick={handleModifyClick} />
    </Container>
  );
};

Static.propTypes = {
  location: PropTypes.string.isRequired,
  license: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  onModifyClick: PropTypes.func.isRequired,
  isRecoveryPoints: PropTypes.bool,
};

Static.defaultProps = {
  isRecoveryPoints: false,
};

export { Static };
